'use strict';

// Constructor
var Slide2 = function () {
    var $counters = {};

    // Create the counter objects
    $('.slide2 .number').each(function () {
        $counters[$(this).data('name')] = new CountUp($(this)[0], 0, $(this).data('end'), $(this).data('decimal'), 2.5, {
            useEasing: true,
            useGrouping: true,
            separator: ',',
            decimal: '.',
            prefix: $(this).data('prefix') ? $(this).data('prefix') : '',
            suffix: $(this).data('suffix') ? $(this).data('suffix') : ''
        });

//        $(this).html('0');
    });

    // When hitting the slide animate the numbers
    $('.slide2').waypoint(function () {
        $('.slide2 .number').each(function () {
            if (!$counters[$(this).data('name')].error) {
                $counters[$(this).data('name')].start();
            } else {
                console.error($counters[$(this).data('name')].error);
            }

            $('.slider button').removeClass('active');
            $('.slider .button_slide2').addClass('active');
            $('.slide2 .right').addClass('active');
        });
    }, {
        offset: '25%'
    });

    $('.slide2').waypoint(function () {
        $('.slider button').removeClass('active');
        $('.slider .button_slide1').addClass('active');
    }, {
        offset: '99%'
    });


};

module.exports = Slide2;
